import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=4cb49a12&scoped=true"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=4cb49a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb49a12",
  null
  
)

export default component.exports